module.exports = __webpack_public_path__ + "static/media/36x36-10.e2228af5.png";